import { ReactNode } from "react";

const PageHeader = ({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) => (
  <div className="flex justify-between items-center flex-wrap gap-3 mb-6">
    <div>
      <h1 className="font-semibold text-2xl text-honeConnectBlack">{title}</h1>
      {subtitle && <p className="text-sm text-hcMuted mt-0.5">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-3">{actions}</div>}
  </div>
);

export default PageHeader;
